module.exports = __webpack_public_path__ + "static/media/our-works-mobile-view.94990153.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Partner/imgs/our-works-mobile-view.jpg
// module id = 1522
// module chunks = 0